import type {BeneficiaryRefund} from 'domain/usecases';
import {ModalityEnum} from 'domain/usecases/private/refund/request-preview';

export const PREVIEW_DATA_DEFAULT = {
	beneficiary: {} as BeneficiaryRefund,
	modality: ModalityEnum.THERAPIES,
	description: '',
	files: [],
	protocol: '',
	protocolCode: '',
	requestCode: '',
	request: '',
	requestDate: '',
};
